import { createBrowserRouter, createMemoryRouter, type RouteObject } from 'react-router-dom';
import { kitRoutes } from './dev/kitRoutes';
import { RequireAdmin, RequireSession } from './guards';
import * as Pages from './lazyPages';
import { NotFound } from './NotFound';
import { RootLayout } from './RootLayout';
import { RootError } from './RootError';

/** Todas las rutas de la app (docs/ARQUITECTURA.md §7). Cada pantalla es un chunk perezoso. */
export const routes: RouteObject[] = [
  ...kitRoutes,
  {
    element: <RootLayout />,
    errorElement: <RootError />,
    children: [
      { index: true, element: <Pages.InicioPage /> },
      { path: 'precios', element: <Pages.PreciosPage /> },
      { path: 'historico', element: <Pages.HistoricoPage /> },
      { path: 'comparador', element: <Pages.ComparadorPage /> },
      { path: 'tendencias', element: <Pages.TendenciasPage /> },
      { path: 'noticias', element: <Pages.NoticiasPage /> },
      { path: 'calculadora', element: <Pages.CalculadoraPage /> },
      { path: 'alertas', element: <Pages.AlertasPage /> },
      { path: 'notificaciones', element: <Pages.NotificacionesPage /> },
      { path: 'cuenta/entrar', element: <Pages.EntrarPage /> },
      { path: 'cuenta/registro', element: <Pages.RegistroPage /> },
      { path: 'cuenta/recuperar', element: <Pages.RecuperarPage /> },
      { path: 'cuenta/restablecer', element: <Pages.RestablecerPage /> },
      { path: 'cuenta/verificar', element: <Pages.VerificarPage /> },
      {
        element: <RequireSession />,
        children: [{ path: 'cuenta', element: <Pages.CuentaPage /> }],
      },
      { path: 'fuentes', element: <Pages.FuentesPage /> },
      { element: <RequireAdmin />, children: [{ path: 'admin/*', element: <Pages.AdminPage /> }] },
      { path: 'ajustes', element: <Pages.AjustesPage /> },
      { path: 'acerca', element: <Pages.AcercaPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export const router = createBrowserRouter(routes);
export const createTestRouter = (initialEntries: string[]) =>
  createMemoryRouter(routes, { initialEntries });
